import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getCentrosCustosPais({ commit }) {
      try {
        const response = await api.get('/centros-custos')

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getCentroCustoPai({ commit }, codCCusto) {
      try {
        const response = await api.get(`/centros-custos/${codCCusto}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
